const grade = {
  gradeTxt: (value) => {
    return `${value}급`
  }
}

export default grade
